import React, { Component } from 'react';

import Loading from '../Loading.js'

import FormText from '../../Fields/FormText.js';
import NamezzzSalary from '../../Fields/NamezzzSalary.js'

import { getPersonSalary, postPersonSalary } from '../../Api/UserActions.js'
import { getSalaryPeriods } from '../../Api/Namezzz.js'

import { getTranslation } from '../../Utilities/GetTranslation.js'


declare var globalSns;

class Salary extends Component {
    constructor(props) {
        super(props);

        this.state = {

        }
        
        this.handleValueChange = this.handleValueChange.bind(this);   
        this.handlePeriodValueChange = this.handlePeriodValueChange.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getSalaryPeriods(globalSns.languageId, (data) => {
            this.setState({
                salaryPeriods: data
            })
        });
        getPersonSalary((data) => {
            this.setState({
                personSalary: data
            });
        });
    }

    saveData(data) {
        postPersonSalary(data.currentSalary, data.currentSalaryPeriod, data.currentExtra, data.preferredSalary, data.preferredSalaryPeriod, data.preferredExtra, (data) => {
        });
    }

    isValidated() {
        if (this.state.personSalary != null) {
            this.saveData(this.state.personSalary);
        }
        
        return true;
    }

    handlePeriodValueChange(e) {
        var newPersonSalary = this.state.personSalary;
        newPersonSalary[e.target.id] = parseInt(e.target.value, 10);

        this.setState({
            personSalary: newPersonSalary
        });
    }

    handleValueChange(e) {
        var newPersonSalary = this.state.personSalary;
        newPersonSalary[e.target.id] = e.target.value;

        this.setState({
            personSalary: newPersonSalary
        });
    }

    render() {

        if (this.state.salaryPeriods == null || this.state.personSalary == null) {
            return (
                <Loading/>
            );
        }

        var currentSalary = (this.state.personSalary.currentSalary == null) ? "" : this.state.personSalary.currentSalary;
        var preferredSalary = (this.state.personSalary.preferredSalary == null) ? "" : this.state.personSalary.preferredSalary;
        var currentExtra = (this.state.personSalary.currentExtra == null) ? "" : this.state.personSalary.currentExtra;
        var preferredExtra = (this.state.personSalary.preferredExtra == null) ? "" : this.state.personSalary.preferredExtra;
        
        return (
            <div>
                <h4 className="legend-title">{getTranslation("sns.webparts.salary.current")}</h4>
                {
                    (this.state.personSalary.workExperience) ?
                        <div>
                            <NamezzzSalary id="currentSalary" text={getTranslation("sns.webparts.salary.currentsalary")} 
                                value={currentSalary} period={this.state.personSalary.currentSalaryPeriod} periodData={this.state.salaryPeriods} 
                                onChange={this.handleValueChange} onPeriodChange={this.handlePeriodValueChange} />
                            <FormText id="currentExtra"
                                rows={5} text={getTranslation("sns.webparts.salary.current.extra")} value={currentExtra}
                                onChange={this.handleValueChange} />
                        </div> :
                        <div>{getTranslation("sns.webparts.salary.noworkexperience")}</div>
                }
                <h4 className="legend-title">{getTranslation("sns.webparts.salary.preferred")}</h4>
                <NamezzzSalary id="preferredSalary" text={getTranslation("sns.webparts.salary.preferredsalary")} 
                                value={preferredSalary} period={this.state.personSalary.preferredSalaryPeriod} periodData={this.state.salaryPeriods} 
                                onChange={this.handleValueChange} onPeriodChange={this.handlePeriodValueChange} />
                <FormText id="preferredExtra"
                    rows={5} text={getTranslation("sns.webparts.salary.preferred.extra")} value={preferredExtra}
                    onChange={this.handleValueChange} />
            </div>
        );
    }
}

export default Salary;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Salary.js